import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=09467d8c&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/help/helpDetails.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/help/helpDetails.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./_id.vue?vue&type=style&index=2&id=09467d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09467d8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HelpBanner: require('/src/components/help/helpBanner.vue').default})
